import classnames from 'classnames';
import type { PropsWithChildren, ReactElement } from 'react';
import styles from './IconButton.module.scss';
import { Button, type Props as ButtonProps } from '../Button';
import FontAwesomeIcon, {
  type Icon,
  type AllowedModifier
} from 'common/components/FontAwesomeIcon';

type IconButtonProps = PropsWithChildren<{
  icon: Icon;
  iconPosition?: 'left' | 'right';
  iconSpin?: boolean;
  iconPulse?: boolean;
}> &
  ButtonProps;

export function IconButton({
  icon,
  children,
  iconPosition = 'right',
  iconSpin = false,
  iconPulse = false,
  ...otherProps
}: IconButtonProps): ReactElement {
  const modifier: AllowedModifier[] = [];
  if (iconSpin) modifier.push('spin');
  if (iconPulse) modifier.push('spin-pulse');

  const leftOrRightIcon = (
    <FontAwesomeIcon
      icon={icon}
      className={classnames({
        [styles.icon]: true,
        [styles.left]: iconPosition === 'left',
        [styles.right]: iconPosition === 'right',
        [styles.spin]: iconSpin,
        [styles.pulse]: iconPulse
      })}
      modifier={modifier}
    />
  );

  return (
    <Button {...otherProps}>
      {iconPosition === 'left' ? leftOrRightIcon : null}
      {children}
      {iconPosition === 'right' ? leftOrRightIcon : null}
    </Button>
  );
}
